<template>
  <h1>Page not found</h1>
</template>

<script>

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "NotFoundComponent"
  }
</script>

<style scoped>

</style>
